








































import BaseComponent from '@/components/base-component.vue';
import { errorHandling } from '@/helpers/errorHandling';
import { PrescricaoParmDTO } from '@/interfaces/prescription';
import * as service from '@/services/prescription';
import { MESSAGE_PRESCRIPTION_COPY_ERROR } from '@/settings/consts/messages';
import * as prescriptionStatus from '@/settings/consts/prescription-status';
import { COPY } from '@/settings/consts/prescriptions-types';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';



@Component
export default class PrescriptionTypesCopy extends BaseComponent {
  @Prop()
  public item;
  @Prop()
  public copyItem;
  @Prop()
  public currentTab: string;
  @Prop()
  public tabName: string;
  @Prop()
  public draft: PrescricaoParmDTO;

  public loading: boolean = false;
  public items: any[] = [];
  public selectedItem: any = {};

  @Watch('item.unidade')
  public onChangeUnit(val: any): void {
    this.load();
  }

  @Watch('item.paciente')
  public onChangePatient(val: any): void {
    this.load();
  }

  @Watch('currentTab')
  public onChangeCurrentTab(): void {
    if (this.currentTab === this.tabName) {
      this.selectedItem = null;
    }
    this.onChangeCopyItem(this.copyItem);
    this.onChangeDraft(this.draft);
  }

  @Watch('copyItem')
  public onChangeCopyItem(copyItem): void {
    if (!copyItem || this.currentTab != this.tabName) {
      return;
    }

    this.selectItemWhenReady(copyItem.idPrescricao);
  }

  @Watch('draft', { immediate: true })
  public onChangeDraft(draft: PrescricaoParmDTO): void {
    if (!draft || !draft.idPrescricaoCopia || draft.tipoPrescricao != COPY) {
      return;
    }

    this.selectItemWhenReady(draft.idPrescricaoCopia);
  }

  selectItemWhenReady(idPrescricao) {
    this.sleepUntil(() => {
      return this.items && this.items.length;
    }, 180000).then(() => {
      this.selectedItem = this.items.find((i) => Number(i.idPrescricao) == idPrescricao);
      this.onChangeSelectedItem(this.selectedItem);
    });
  }

  public onChangeSelectedItem(val: any) {
    if (!val || !val.idPrescricao) {
      return;
    }

    this.loader.start();

    const onError = (error) => {
      this.loader.stop();
      const errorMessages = {
        default: MESSAGE_PRESCRIPTION_COPY_ERROR,
      };

      const message = errorHandling(error, errorMessages);
      this.toast.show(message, 'error');
    };

    service.getPrescription(val.idPrescricao).subscribe((data) => {
      this.$emit('change', data);
      this.loader.stop();
    }, onError);
  }

  public beforeMount(): void {
    this.load();
  }

  public showEmptyState(): boolean {
    return (
      !this.loading &&
      !this.items.length &&
      !!this.item.paciente &&
      !!this.item.paciente.id &&
      !!this.item.unidade &&
      !!this.item.unidade.id
    );
  }

  public onFilter(item: any, queryText: string, itemText: string): boolean {
    const patientName = item.paciente.toLowerCase();
    const date = item.dataEntrega.toLowerCase();
    const doctorName = item.medico.toLowerCase();
    const searchText = queryText.toLowerCase();

    return (
      patientName.indexOf(searchText) > -1 ||
      date.indexOf(searchText) > -1 ||
      doctorName.indexOf(searchText) > -1
    );
  }

  public load(): void {
    this.selectedItem = {};
    this.items = [];

    if (
      !this.item.unidade ||
      !this.item.unidade.id ||
      !this.item.paciente ||
      !this.item.paciente.id
    ) {
      return;
    }

    this.loading = true;

    service.listPrescriptionsModelsCombo(this.item.paciente.id, this.item.unidade.id).subscribe(
      (data) => {
        this.items = data;
        this.loading = false;
      },
      () => {
        this.loading = false;
      },
    );
  }
}
